module.exports = __webpack_public_path__ + "img/serwis-expres.50dfb4dc.jpg";